import { useState, useEffect, useCallback } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { connect } from 'react-redux';

// icn
import { ReactComponent as EditIcn } from "../../../../../../Assets/Images/icn/pencil.svg";
import EnableDisablePop from "components/Modals/EnableDisablePop";
//imported
import { addUpdateAccountSetting_ } from 'store/services/accountSettingService';
import { parseAutoLogoutLabel } from "helpers/common";

const AccountSetting = ({dispatch, accountSettingList, setSuccessResponse, sending, setSending, currentTabValue, setCurrentTabValue}) => {
  const [editDisplayName, setDisplayName] = useState();
  const [onOffPop, setOnOffPop] = useState();
  const [popHeading, setPopHeading] = useState("");
  const [editSettingKey, setEditSettingKey] = useState(null);

  const handleOnOff = (heading, value) => {
    setOnOffPop(!onOffPop);
    setPopHeading(heading);
    setCurrentTabValue(value)
  };

  const [fields, setfields] = useState({
    data_set : currentTabValue ? currentTabValue.data_set : ""
  })

  useEffect(() => {
    if (currentTabValue) {
      setfields(prevState => ({
        ...prevState,
        ...currentTabValue,
      }))
    }
  }, [currentTabValue, accountSettingList])

  //submit setting data
  const handleSubmit = async (evt) => {
    try{
      evt.preventDefault();
        let final_obj = {
          data_set : fields.data_set
        }
        let fieldsId = fields.id
        // return
        final_obj = JSON.stringify(final_obj)
        setSending(true)
        setSuccessResponse(false)
        await dispatch(addUpdateAccountSetting_(fieldsId, final_obj));
        setSending(false)
        setDisplayName(false)
        setSuccessResponse(true)
        setOnOffPop(false)
        setCurrentTabValue(null)
        setEditSettingKey(null);
    } catch (err) {
        console.log(err);
        setSending(false)
        setSuccessResponse(false)
    }
  }

  //handle changes
  const handleChange = useCallback(
    name => evt => {
      setfields(prevState => ({
        ...prevState,
        [name]: evt.target.value,
      }))
    },
    []
  )
  
  return (
    <>
      <EnableDisablePop
        heading={popHeading}
        onOffPop={onOffPop}
        setOnOffPop={setOnOffPop}
        currentTabValue={currentTabValue}
        setCurrentTabValue={setCurrentTabValue}
        handleSubmit={handleSubmit}
        handleChange={handleChange('data_set')}
        sending={sending}
      />

      <div className="top py-2">
        <h3 className="m-0 py-1 fw-bold">Account Setting</h3>
      </div>
      <div className="TabBody py-3">
        {accountSettingList?.length > 0 && accountSettingList?.map((settingList, idx) => {
          return(
            <div key={idx}>
              {settingList.data_key === "auto_logout_duration" &&
                <div className="py-2">
                  <div className="commonCardBox p-3">
                    <div className="top d-flex align-items-center justify-content-between gap-10">
                      <div className="left">
                        <h6 className="m-0 fw-bold">
                          Automatic Logoff Duration:{" "}
                          <span className="fw-normal">
                            ({ parseAutoLogoutLabel(settingList.data_set) })
                          </span>
                        </h6>
                      </div>
                      <div className="right">
                        <Button
                          onClick={() => {
                            setCurrentTabValue(settingList);
                            setEditSettingKey("auto_logout_duration")
                          }}
                          className="d-flex align-items-center fw-bold commonBtn btnSm justify-content-center py-2 px-3"
                        >
                          <span className="icn me-2">
                            <EditIcn />
                          </span>
                          Edit
                        </Button>
                      </div>
                    </div>
                    <div className="CardBody py-2">
                      <p className="m-0">
                        By default your account is signed out after 48 Hours of inactivity.
                        You can edit this setting to change the amount of time before your account is automatically signed out.
                      </p>
                      {editSettingKey == "auto_logout_duration" && (
                        <>
                          <div className="commonCardBox p-3 mt-3">
                            <Form onSubmit={handleSubmit}>
                              <Row>
                                <Col lg="6" className="my-2">
                                  <Form.Select
                                    value={fields.data_set}
                                    onChange={handleChange("data_set")}
                                  >
                                    <option value={900}>15 Minutes</option>
                                    <option value={3600}>1 Hour</option>
                                    <option value={86400}>24 Hours</option>
                                    <option value={172800}>48 Hours</option>
                                    <option value={604800}>1 Week</option>
                                    <option value={1209600}>2 Weeks</option>
                                  </Form.Select>
                                </Col>
                                <Col lg="12" className="my-2">
                                  <div className="FormbtnWrpper d-flex align-items-center gap-10">
                                    <Button
                                      onClick={() => setEditSettingKey(null)}
                                      className="d-flex align-items-center justify-content-center commonBtn btnSm"
                                    >
                                      Cancel
                                    </Button>
                                    <Button
                                      type="submit"
                                      className="d-flex align-items-center justify-content-center commonBtn btnSm"
                                    >
                                    {sending ? 'wait...' : 'Update'}
                                    </Button>
                                  </div>
                                </Col>
                              </Row>
                            </Form>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              }
            </div>
          )
        })}
      </div>
    </>
  );
};


const mapStateToPros = (state) => {
  return{
      // accountSettingList: state.AccountSetting.accountSettingList,
  }
};

function mapDispatchToProps(dispatch) {
return { dispatch };
}

export default connect(
mapStateToPros,
mapDispatchToProps
)(AccountSetting);
